class ImageHoverGallery extends HTMLElement {
  connectedCallback() {
    const secondary = this.querySelector(":scope > img:first-of-type");
    const primary = this.querySelector(":scope > img:last-of-type");
    if (!primary || !secondary || primary === secondary) return;

    let preloaded = false;
    const ensureSecondaryLoaded = () => {
      if (preloaded) return Promise.resolve();
      preloaded = true;
      if (secondary.loading === "lazy") secondary.loading = "eager";
      const ready = secondary.complete && secondary.naturalWidth > 0
        ? Promise.resolve()
        : (secondary.decode ? secondary.decode() : Promise.resolve());
      return ready.catch(() => {});
    };

    this._enter = () => {
      ensureSecondaryLoaded().then(() => {
        if (!this.matches(":hover")) return;
        secondary.style.opacity = "1";
        primary.style.opacity = "0";
      });
    };
    this._leave = () => {
      secondary.style.opacity = "0";
      primary.style.opacity = "1";
    };

    this.addEventListener("mouseenter", this._enter);
    this.addEventListener("mouseleave", this._leave);
  }

  disconnectedCallback() {
    this.removeEventListener("mouseenter", this._enter);
    this.removeEventListener("mouseleave", this._leave);
  }
}

customElements.define("image-hover-gallery", ImageHoverGallery);
